export const mutationKeys = {
  pixPaymentKey: () => ['pix-payment'] as const,
  requestImmediateAttendanceKey: () =>
    ['request-immediate-attendance'] as const,
  requestScheduleAttendanceKey: () => ['request-schedule-attendance'] as const,
  createAttendanceRecurrenceKey: () =>
    ['create-attendance-recurrence'] as const,
  confirmReservationConsultationKey: () =>
    ['confirm-reservation-consultation'] as const,
} as const
